import React from 'react';

export function useLocalStorage<T>(
  key: string,
  defaultValue: T,
  // When true, persistence is off: never read from or write to localStorage, and purge any stale
  // entry left by a prior session so it can't silently rehydrate the state.
  disabled = false
): [T, React.Dispatch<React.SetStateAction<T>>, () => void] {
  const [value, setValue] = React.useState<T>(() => {
    if (disabled) {
      return defaultValue;
    }
    const result = localStorage.getItem(key);

    if (result) {
      return JSON.parse(result);
    }
    return defaultValue;
  });

  const removeValue = (): void => localStorage.removeItem(key);

  React.useEffect(() => {
    if (disabled) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value, disabled]);

  return [
    value,
    (newValue) => {
      setValue(newValue);
    },
    removeValue,
  ];
}
